import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 20px;
  min-height: 80vh;
`

export const Header = styled.div`
  text-align: center;
  margin-bottom: 60px;

  h1 {
    font-size: 3rem;
    margin-bottom: 16px;
    color: ${({ theme }) => theme.colors.text};

    @media (max-width: 768px) {
      font-size: 2rem;
    }
  }

  p {
    font-size: 1.2rem;
    color: ${({ theme }) => theme.colors.textSecondary};
    max-width: 600px;
    margin: 0 auto;
  }
`

export const PlansContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 32px;
  margin-bottom: 48px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const PlanCard = styled.div`
  background: ${({ theme }) => theme.colors.cardBackground};
  border: 2px solid ${({ theme, $featured }) => ($featured ? theme.colors.primary : theme.colors.border)};
  border-radius: 16px;
  padding: 40px 32px;
  position: relative;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
  box-shadow: ${({ $featured }) =>
    $featured ? '0 8px 32px rgba(100, 100, 255, 0.2)' : '0 4px 16px rgba(0, 0, 0, 0.1)'};

  ${({ $featured }) =>
    $featured &&
    `
    transform: scale(1.05);
  `}

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 40px rgba(100, 100, 255, 0.3);
  }

  @media (max-width: 768px) {
    ${({ $featured }) =>
      $featured &&
      `
      transform: scale(1);
    `}
  }
`

export const Badge = styled.div`
  background: ${({ theme }) => theme.colors.primary};
  color: white;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const PlanHeader = styled.div`
  text-align: center;
  margin-bottom: 24px;

  h2 {
    font-size: 1.8rem;
    margin-bottom: 8px;
    color: ${({ theme }) => theme.colors.text};
  }

  p {
    color: ${({ theme }) => theme.colors.textSecondary};
    font-size: 0.95rem;
  }
`

export const Price = styled.div`
  text-align: center;
  margin-bottom: 32px;

  .amount {
    font-size: 3.5rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.primary};
    line-height: 1;

    .currency {
      font-size: 1.5rem;
      vertical-align: super;
    }
  }

  .period {
    color: ${({ theme }) => theme.colors.textSecondary};
    font-size: 1rem;
    margin-top: 8px;
  }

  .savings {
    background: ${({ theme }) => theme.colors.success}20;
    color: ${({ theme }) => theme.colors.success};
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 0.85rem;
    font-weight: 600;
    margin-top: 8px;
    display: inline-block;
  }

  .original-price-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 6px;
  }

  .original-price {
    color: ${({ theme }) => theme.colors.textSecondary};
    font-size: 0.95rem;
    text-decoration: line-through;
    opacity: 0.7;
  }

  .discount-tag {
    background: #ff4d4d;
    color: white;
    padding: 2px 8px;
    border-radius: 8px;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.3px;
  }
`

export const FeaturesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 32px 0;

  li {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 0;
    color: ${({ theme }) => theme.colors.text};
    font-size: 0.95rem;

    svg {
      color: ${({ theme }) => theme.colors.success};
      flex-shrink: 0;
      margin-top: 2px;
    }
  }
`

export const SubscribeButton = styled.button`
  width: 100%;
  background: ${({ theme, $primary }) => ($primary ? theme.colors.primary : theme.colors.cardBackground)};
  color: ${({ theme, $primary }) => ($primary ? 'white' : theme.colors.text)};
  border: ${({ theme, $primary }) => ($primary ? 'none' : `2px solid ${theme.colors.border}`)};
  padding: 16px 32px;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background: ${({ theme, $primary }) => ($primary ? theme.colors.primaryHover : theme.colors.hoverBackground)};
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(100, 100, 255, 0.3);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const CurrentPlanBadge = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.success}20;
  color: ${({ theme }) => theme.colors.success};
  border: 2px solid ${({ theme }) => theme.colors.success};
  padding: 16px 32px;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  text-align: center;
`

export const LoginPrompt = styled.div`
  text-align: center;
  padding: 48px 24px;
  background: ${({ theme }) => theme.colors.cardBackground};
  border-radius: 16px;
  border: 2px dashed ${({ theme }) => theme.colors.border};

  h3 {
    font-size: 1.5rem;
    margin-bottom: 16px;
    color: ${({ theme }) => theme.colors.text};
  }

  p {
    color: ${({ theme }) => theme.colors.textSecondary};
    margin-bottom: 24px;
  }
`

export const LoginButton = styled(Link)`
  display: inline-block;
  background: ${({ theme }) => theme.colors.primary};
  color: white;
  padding: 14px 32px;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.primaryHover};
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(100, 100, 255, 0.3);
  }
`

export const FAQ = styled.div`
  max-width: 800px;
  margin: 80px auto 0;
  padding-top: 48px;
  border-top: 2px solid ${({ theme }) => theme.colors.border};

  h2 {
    text-align: center;
    font-size: 2rem;
    margin-bottom: 40px;
    color: ${({ theme }) => theme.colors.text};
  }
`

export const FAQItem = styled.div`
  margin-bottom: 24px;
  background: ${({ theme }) => theme.colors.cardBackground};
  border-radius: 12px;
  padding: 24px;
  border: 1px solid ${({ theme }) => theme.colors.border};

  h3 {
    font-size: 1.2rem;
    margin-bottom: 12px;
    color: ${({ theme }) => theme.colors.text};
  }

  p {
    color: ${({ theme }) => theme.colors.textSecondary};
    line-height: 1.6;
  }
`
